import React, { useState } from 'react'
//import { randomInt } from './constants'
//import MongoContext from './MongoContext'
import { mongodb, useAuth } from './Auth//use-auth'
//import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardHeader from '@material-ui/core/CardHeader'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import { useHistory } from 'react-router-dom'
// #f3f6f900
const useStyles = makeStyles(theme => ({
  card: {
    padding: '1em',
    alignItems: 'stretch'
  },
  cardContent: {
    padding: '1em',
    alignItems: 'stretch'
  },
  cardHeader: {
    backgroundColor: '#f3f6f900',
    alignItems: 'stretch'
  },
  pushButton: {
    fullWidth: true,
    variant: 'outlined',
    color: 'primary'
  },
  toolbar: {
    display: 'contents',
    backgroundColor: '#f3f6f900',
    position: 'fixed',
    width: 'auto',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 'auto',
      marginTop: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  appb: {
    backgroundColor: '#d5e0eac7',
    display: 'block'
  },
  mainGrid: {
    paddingTop: '7%'
  }
}))

export default function HeaderItem (props) {
  const classes = useStyles()
  const { auth, user } = useAuth()
  const [groups, setGroups] = useState([{}])
  const history = useHistory()
  // const [value, setValue] = useState({
  //   title: '',
  //   rightTitle: '',
  //   StackItems: false,
  //   height: 30,
  //   items: []
  // })
  const db = mongodb.db('silmandDB')
  // const handleChange = data => {
  //   if (data.title) setValue(prevState => ({ ...prevState, title: data.title }))
  //   if (data.rightTitle)
  //     setValue(prevState => ({ ...prevState, rightTitle: data.rightTitle }))
  // }
  //const { id, algus, depart, kuup, lopp, tunnid, unixtime } = props

  //const [confirm, setConfirm] = React.useState(false)

  React.useEffect(() => {
    if (user) {
      listGroups()
    } else {
      console.log('ei toimi', auth)
      window.alert('Vaja sisse logida')
      props.history.push('/')
      console.log('ei toimi', auth)
    }
  }, [])

  const listGroups = async () => {
    try {
      await db
        .collection('groups')
        .find({}, { sort: { title: 1 } })
        .asArray()
        .then(gr => {
          setGroups(gr)
        })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
    }
  }

  // const handleDelete = (e, id) => {
  //   console.log('delete', e)
  // } #d5e0eac7

  return (
    <React.Fragment>
      <AppBar className={classes.appb}>
        <Toolbar className={classes.toolbar}>
          <Link
            component={Button}
            to={{
              pathname: `/insert/insert`,
              query: {
                id: '',
                title: '',
                email: '',
                phone: '',
                hidden: false
              }
            }}
          >
            <Button fullWidth variant='outlined' color='primary'>
              Lisa Grupi Liige
            </Button>
          </Link>
          <Button
            onClick={() => history.go(-1)}
            variant='outlined'
            color='primary'
          >
            Tagasi
          </Button>
        </Toolbar>
      </AppBar>
      <Grid
        container
        spacing={2}
        alignItems='stretch'
        className={classes.mainGrid}
      >
        {groups.map((group, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Card key={group._id} className={classes.card}>
              <CardHeader
                title={group.title}
                subheader={`Telefon: ${group.phone}    E-meil:${group.email}`}
                titleTypographyProps={{ align: 'center' }}
                subheaderTypographyProps={{ align: 'center' }}
                action={null}
                className={classes.cardHeader}
              />

              <CardActions className={classes.cardContent}>
                <Link
                  to={{
                    pathname: `/insert/change`,
                    query: {
                      id: group._id,
                      title: group.title,
                      email: group.email,
                      phone: group.phone,
                      hidden: group.hidden
                    }
                  }}
                >
                  <Button fullWidth variant='outlined' color='primary'>
                    Muuda
                  </Button>
                </Link>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  )
}
